import Youtube24 from '@honeybook/icons/dist/icons/Youtube24';
import Vimeo24 from '@honeybook/icons/dist/icons/Vimeo24';
import Wistia24 from '@honeybook/icons/dist/icons/Wistia24';
import Loom24 from '@honeybook/icons/dist/icons/Loom24';
import Soundcloud24 from '@honeybook/icons/dist/icons/Soundcloud24';
import PicTime24 from '@honeybook/icons/dist/icons/PicTime24';
import { IconProps } from '@honeybook/icons/dist/types/Icon.interface';

export enum StreamingPlatform {
    Youtube = 'Youtube',
    Vimeo = 'Vimeo',
    Wistia = 'Wistia',
    Loom = 'Loom',
    SoundCloud = 'SoundCloud',
    PicTime = 'PicTime'
}

export type IframeStreamingPlatform =
    | StreamingPlatform.PicTime
    | StreamingPlatform.Loom;

export type TReactPlayerSupportedPlatforms = Exclude<
    StreamingPlatform,
    IframeStreamingPlatform
>;

export const STREAMING_PLATFORM_DATA: Record<
    StreamingPlatform,
    {
        domainRegex: string;
        icon: (props: IconProps) => JSX.Element;
        regexTerm: string;
        platformName: string;
        customValidtion?: (url: string) => boolean;
    }
> = {
    [StreamingPlatform.Youtube]: {
        domainRegex: 'youtu(be.com|.be|be.googleapis.com)',
        icon: Youtube24,
        regexTerm: 'youtu',
        platformName: 'YouTube'
    },
    [StreamingPlatform.Vimeo]: {
        domainRegex: 'vimeo.com',
        icon: Vimeo24,
        regexTerm: 'vimeo',
        platformName: 'Vimeo'
    },
    [StreamingPlatform.Wistia]: {
        domainRegex: '(wistia.(net|com))|wi.st',
        icon: Wistia24,
        regexTerm: 'wi',
        platformName: 'Wistia'
    },
    [StreamingPlatform.Loom]: {
        domainRegex: 'loom.com',
        icon: Loom24,
        regexTerm: 'loom',
        platformName: 'Loom'
    },
    [StreamingPlatform.SoundCloud]: {
        domainRegex: 'soundcloud.com',
        icon: Soundcloud24,
        regexTerm: 'soundcloud',
        platformName: 'SoundCloud'
    },
    [StreamingPlatform.PicTime]: {
        domainRegex: 'pic\\-time\\.com',
        icon: PicTime24,
        regexTerm: 'pic-time',
        platformName: 'PicTime',
        customValidtion: url => new RegExp('/_pt_').test(url)
    }
};
